import { getIOSMessageHandlers, getAndroidMessageHandlers } from "./api/messageHandlers";

/**
   * Sends a buyflowExit message to the native app
   * @param payload - Optional payload to send with the message
   * @returns true if the message was sent successfully, false otherwise.
   */
export const sendBuyflowExit = (payload?: any) => {
    if (isInsideIOSWebKit()) {
      try {
        const messageHandlers = getIOSMessageHandlers();
        if (messageHandlers?.buyflowExit) {
          if (payload) {
            messageHandlers.buyflowExit.postMessage(payload);
          } else {
            messageHandlers.buyflowExit.postMessage({});
          }
          return true;
        }
      } catch (err) {
        console.error(err, "sendBuyflowExit.ios");
      }
    }
    if (isInsideAndroidWebView()) {
      try {
        const messageHandlers = getAndroidMessageHandlers();
        if (messageHandlers?.buyflowExit) {
          if (payload) {
            messageHandlers.buyflowExit(JSON.stringify(payload));
          } else {
            messageHandlers.buyflowExit();
          }
          return true;
        }
      } catch (err) {
        console.error(err, "sendBuyflowExit.android");
      }
    }
    
    return false;
  }

/**
   * Sends a webviewExit message to the native app
   * @param payload - Optional payload to send with the message
   * @returns true if the message was sent successfully, false otherwise.
   */
export const sendWebviewExit = (payload?: any) => {
    if (isInsideIOSWebKit()) {
      try {
        const messageHandlers = getIOSMessageHandlers();
        if (messageHandlers?.webviewExit) {
          if (payload) {
            messageHandlers.webviewExit.postMessage(JSON.stringify(payload));
          } else {
            messageHandlers.webviewExit.postMessage(JSON.stringify({}));
          }
          return true;
        }
      } catch (err) {
        console.error(err, "sendWebviewExit.ios");
      }
    }
    if (isInsideAndroidWebView()) {
      try {
        const messageHandlers = getAndroidMessageHandlers();
        if (messageHandlers?.webviewExit) {
          if (payload) {
            messageHandlers.webviewExit(JSON.stringify(payload));
          } else {
            messageHandlers.webviewExit();
          }
          return true;
        }
      } catch (err) {
        console.error(err, "sendWebviewExit.android");
      }
    }
    
    return false;
  }

  export function isInsideIOSWebKit(): boolean {
    return !!getIOSMessageHandlers();
  }
  
  export function isInsideAndroidWebView(): boolean {
    return !!getAndroidMessageHandlers();
  }
  
  export function isInsideWebView() {
    return isInsideIOSWebKit() || isInsideAndroidWebView();
  }